module.exports = __webpack_public_path__ + "img/G26-egypt.01f100a1.png";